import React, { useReducer, useContext, createContext, useMemo } from 'react';
import { autocompleteContext } from './reducer';

const Store = createContext();

Store.displayName = 'PNP-STORE';

export const useStore = () => useContext(Store);

export const StoreProvider = ({
    children,
    initialState,
    reducer,
    autocompleteService,
}) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const autocomplete = useMemo(
        () => autocompleteContext(dispatch, autocompleteService),
        []
    );

    return (
        <Store.Provider value={{ ...autocomplete, dispatch, ...state }}>
            {children}
        </Store.Provider>
    );
};
